import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_goofy-hypatia-3/artifacts/xykys01p_Omlight%20Logo%20PNG.png";

// Full-color brand SVG icons
const FacebookIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const YoutubeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#1A202C] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src={LOGO_URL}
              alt="Omlight Publications"
              className="h-[5.5rem] w-auto mb-6 drop-shadow-lg"
            />
            <p className="font-sans text-[#A0AEC0] text-sm leading-relaxed max-w-md">
              An independent imprint founded and operated by Linda D. Gallagher, dedicated to sharing
              spiritual and inspirational works that support seekers of truth, healing, and inner freedom.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg mb-4 text-[#D4AF37]">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#book"
                  data-testid="footer-link-book"
                  className="font-sans text-sm text-[#A0AEC0] hover:text-white transition-colors"
                >
                  The Book
                </a>
              </li>
              <li>
                <a
                  href="#author"
                  data-testid="footer-link-author"
                  className="font-sans text-sm text-[#A0AEC0] hover:text-white transition-colors"
                >
                  Meet Linda
                </a>
              </li>
              <li>
                <a
                  href="#reflections"
                  data-testid="footer-link-media"
                  className="font-sans text-sm text-[#A0AEC0] hover:text-white transition-colors"
                >
                  Media Content
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  data-testid="footer-link-contact"
                  className="font-sans text-sm text-[#A0AEC0] hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="font-serif text-lg mb-4 text-[#D4AF37]">Community</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://acenteroffreedom.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-center"
                  className="font-sans text-sm text-[#A0AEC0] hover:text-white transition-colors"
                >
                  A Center of Freedom
                </a>
              </li>
              <li>
                <a
                  href="https://acenteroffreedom.org/power-of-music/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-music"
                  className="font-sans text-sm text-[#A0AEC0] hover:text-white transition-colors"
                >
                  Music & Devotion
                </a>
              </li>
              <li>
                <a
                  href="https://shop.ingramspark.com/b/084?params=WOjJaIkWSWaOGLiXcoDCT2QxXTvD81n1g0bmkVhVhbs"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-order"
                  className="font-sans text-sm text-[#A0AEC0] hover:text-white transition-colors"
                >
                  Order The Book
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2D3748] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans text-xs text-[#718096]">
            &copy; {currentYear} Omlight Publications. All rights reserved.
          </p>
          
          {/* Social Links - Larger, full-color brand icons */}
          <div className="flex items-center gap-5">
            <a
              href="https://www.facebook.com/omlightpublications/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="w-10 h-10 rounded-full bg-[#1877F2] flex items-center justify-center text-white hover:scale-110 hover:shadow-lg hover:shadow-[#1877F2]/30 transition-all duration-300"
              aria-label="Facebook"
            >
              <FacebookIcon className="w-5 h-5" />
            </a>
            <a
              href="https://www.youtube.com/@OmlightPublications"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-youtube-link"
              className="w-10 h-10 rounded-full bg-[#FF0000] flex items-center justify-center text-white hover:scale-110 hover:shadow-lg hover:shadow-[#FF0000]/30 transition-all duration-300"
              aria-label="YouTube"
            >
              <YoutubeIcon className="w-5 h-5" />
            </a>
          </div>
          
          <div className="flex items-center gap-6">
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="font-sans text-xs text-[#718096] hover:text-[#A0AEC0] transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
